import { Button, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import { getTransportationList } from "states/transportation/transportation.api";
import {
  TransportationCodeConst,
  TransportationModel,
} from "states/transportation/transportation.models";
import { TransportationApiModal } from "./transportation-api-modal";

export interface ITransportationSettingProps {}

export function TransportationSetting(props: ITransportationSettingProps) {
  const [transportations, setTransportations] = useState<TransportationModel[]>(
    []
  );
  const [apiModalProps, setApiModalProps] = useState<{
    show: boolean;
    transportation?: TransportationModel;
  }>({
    show: false,
    transportation: undefined,
  });

  const columns: ColumnsType<TransportationModel> = [
    {
      title: "Nhà vận chuyển",
      dataIndex: "gatewayName",
      key: "gatewayName",
      render: (gatewayName: string, item) => item.transportationName,
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      render: (action: string, item) =>
        item.transportationCode !== TransportationCodeConst.Customize && (
          <Button
            type="primary"
            onClick={() => {
              setApiModalProps({
                show: true,
                transportation: item,
              });
            }}
          >
            Cấu hình API
          </Button>
        ),
    },
  ];

  useEffect(() => {
    getTransportationList().then((res) => setTransportations(res.data));
  }, []);

  return (
    <div>
      <Table
        columns={columns}
        rowKey={(row) => row.transportationCode}
        dataSource={transportations}
        size="small"
      ></Table>
      <TransportationApiModal
        show={apiModalProps.show}
        transportation={apiModalProps.transportation}
        closeModal={() => {
          setApiModalProps({
            show: false,
            transportation: undefined,
          });
        }}
      />
    </div>
  );
}
